(() => {
  const hideInboxActivator = () => {
    document.querySelectorAll('shopify-chat, shopify-agent, shopify-agent-bundle, #shopify-chat').forEach((element) => {
      element.style.setProperty('display', 'none', 'important');
    });
  };
  hideInboxActivator();
  new MutationObserver(hideInboxActivator).observe(document.documentElement, { childList: true, subtree: true });

  const flowId = () => {
    const key = 'arteefy-maker20-flow-id';
    let value = sessionStorage.getItem(key);
    if (!value) {
      value = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`).slice(0, 64);
      sessionStorage.setItem(key, value);
    }
    return value;
  };

  const roots = document.querySelectorAll('[data-maker-package-claim]');
  roots.forEach((root) => {
    const button = root.querySelector('[data-claim-button]');
    const ready = root.querySelector('[data-state-ready]');
    const auth = root.querySelector('[data-state-auth]');
    const success = root.querySelector('[data-state-success]');
    const error = root.querySelector('[data-claim-error]');
    const title = root.querySelector('[data-claim-title]');
    const balance = root.querySelector('[data-claim-balance]');
    const login = root.querySelector('[data-claim-login]');
    const register = root.querySelector('[data-claim-register]');
    const campaign = root.dataset.campaign;
    const claimEndpoint = root.dataset.claimEndpoint;
    const intentEndpoint = root.dataset.intentEndpoint;
    const eventEndpoint = root.dataset.eventEndpoint;
    const flow = flowId();
    let busy = false;

    if (!button || !campaign || !claimEndpoint || !intentEndpoint) return;

    const track = (type, extra = {}) => {
      if (!eventEndpoint) return;
      fetch(eventEndpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ type, campaign, extra: { flow_id: flow, ...extra } }),
      }).catch(() => {}); // 观测不得阻断客户领取；服务端会记录可用调用。
    };

    const setView = (view) => {
      ready.hidden = view !== 'ready';
      auth.hidden = view !== 'auth';
      success.hidden = view !== 'success';
      if (view === 'auth') auth.focus();
      if (view === 'success') success.focus();
    };

    const resetButton = () => {
      busy = false;
      button.disabled = false;
      button.textContent = 'Claim 20 Free Designs';
    };

    const clearClaimQuery = () => {
      const url = new URL(window.location.href);
      url.searchParams.delete('claim');
      url.searchParams.delete('intent');
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const showError = (code) => {
      const messages = {
        claim_intent_expired: 'Your sign-in took too long. Please claim again to create a fresh secure link.',
        claim_intent_invalid: 'We could not confirm this claim link. Please start your claim again.',
        claim_receipt_incomplete: 'We could not confirm your updated balance. No designs were added. Please try again.',
        claim_unavailable: 'Claiming is temporarily unavailable. Please try again shortly.',
      };
      error.textContent = messages[code] || 'We could not complete the claim. No designs were added. Please try again.';
      error.hidden = false;
      setView('ready');
      clearClaimQuery();
      resetButton();
    };

    const authUrlWithIntent = (base, intent) => {
      const url = new URL(base, window.location.origin);
      const returnTo = `/maker20?claim=1&intent=${encodeURIComponent(intent)}`;
      url.searchParams.set('return_to', returnTo);
      return url.toString();
    };

    const showAuth = (intent) => {
      if (login) login.href = authUrlWithIntent(root.dataset.loginUrl, intent);
      if (register) register.href = authUrlWithIntent(root.dataset.registerUrl, intent);
      track('claim_auth_start', { intent_present: true });
      setView('auth');
      busy = false;
    };

    const fetchJson = async (url, body = undefined) => {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {}),
      });
      const data = await response.json().catch(() => ({}));
      return { response, data };
    };

    const mintIntent = async () => {
      const { response, data } = await fetchJson(intentEndpoint);
      if (!response.ok || data.ok !== true || typeof data.intent !== 'string' || !data.intent) {
        throw new Error(data.error || 'claim_unavailable');
      }
      return data;
    };

    const completeClaim = async (intent) => {
      const { response, data } = await fetchJson(claimEndpoint, { campaign, intent });
      const serverCode = data.error || data.detail || '';
      if (serverCode === 'not_logged_in') {
        showAuth(intent);
        return 'auth';
      }
      if (!response.ok || data.ok !== true || (!data.claimed && !data.already_claimed)) {
        throw new Error(data.error || 'claim_unavailable');
      }

      // ★假成功防线：HTTP 200/ok 都不足；必须拿到同一账本事务返回的余额。
      const finalBalance = Number(data.after ?? data.free_left);
      if (!Number.isFinite(Number(data.after ?? data.free_left))) {
        throw new Error('claim_receipt_incomplete');
      }

      if (data.already_claimed) {
        title.textContent = 'This account has already claimed its 20 free designs.';
      } else {
        title.textContent = '20 free designs added to this account.';
      }
      balance.textContent = `${finalBalance} designs available`;
      error.hidden = true;
      setView('success');
      track('claim_result', {
        result: data.already_claimed ? 'already_claimed' : 'claimed',
        after: finalBalance,
        delta: Number(data.delta || 0),
      });
      clearClaimQuery();
      busy = false;
      return 'success';
    };

    const beginClaim = async (intent = '') => {
      if (busy) return;
      busy = true;
      button.disabled = true;
      button.textContent = intent ? 'Adding your 20 designs...' : 'Preparing your secure claim...';
      error.hidden = true;
      try {
        let currentIntent = intent;
        if (!currentIntent) {
          track('claim_cta');
          const minted = await mintIntent();
          currentIntent = minted.intent;
          if (!minted.authenticated) {
            showAuth(currentIntent);
            return;
          }
        }
        const outcome = await completeClaim(currentIntent);
        if (outcome !== 'success' && outcome !== 'auth') resetButton();
      } catch (claimError) {
        track('claim_result', { result: 'error', error: String(claimError?.message || 'claim_unavailable').slice(0, 48) });
        showError(claimError?.message || 'claim_unavailable');
      }
    };

    track('claim_landing');
    button.addEventListener('click', () => beginClaim());
    const query = new URL(window.location.href).searchParams;
    const returnedIntent = query.get('claim') === '1' ? query.get('intent') : '';
    if (returnedIntent) {
      track('claim_auth_callback', { intent_present: true });
      beginClaim(returnedIntent);
    }
  });
})();
